<template>
  <el-cascader
     v-model="value"
     :options="hierarchy"
     :clearable="true"
     :show-all-levels="false"
     :placeholder="placeholder"
     :change-on-select="true"
     @change="handleChange"
     :props="props"
     class="hierarchy-filter"
     :disabled="disabled"
     />
</template>

<script>
import Filter from './filter.js'
import customGraphApiAware from '../mixins/customGraphApiAware'

export default {
  mixins: [Filter, customGraphApiAware],
  data () {
    return {
      props: {
        label: 'caption',
        value: 'uniqueName'
      },
      value: [],
      debounce: null
    }
  },
  created () {
    this.updateDefault()
  },
  computed: {
    hierarchy () {
      const map = {}
      const hierarchy = []
      this.values.forEach(v => {
        v = JSON.parse(JSON.stringify(v))
        if (v.level === '1') {
          hierarchy.push(v)
        } else {
          if (typeof map[v.parent].children === 'undefined') {
            map[v.parent].children = []
          }
          map[v.parent].children.push(v)
        }
        map[v.uniqueName] = v
      })
      return hierarchy
    }
  },
  methods: {
    setValues (values, clearDefault) {
      if (!values) {
        return Promise.resolve()
      }
      this.clearDefault = clearDefault || true
      return this.load().then(() => {
        if (values && values.length) {
          let parent = values[0].parent
          const value = [values[0].uniqueName]
          for (let i = parseInt(values[0].level) - 1; i > 0; --i) {
            const index = this.values.findIndex(v => v.uniqueName === parent)
            value.unshift(this.values[index].uniqueName)
            parent = this.values[index].parent
          }
          this.value.splice(0, this.value.length, ...value)
        } else {
          this.reset()
        }
      })
    },
    handleChange () {
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.$emit('change', {
          dimension: this.api.dimension.uniqueName(this.data.value),
          values: this.values.filter(v => {
            return this.value[this.value.length - 1] === v.uniqueName
          })
        })
      }, 1000)
    }
  }
}
</script>

<style lang="less">
.hierarchy-filter {

    .el-input__inner {
        &::placeholder {
            color: rgb(64, 158, 255)!important;
            font-weight: bold;
            opacity: 1;
        }
    }

    .is-focus .el-input__inner {
        border: 1px solid #C3C3CB!important;
        &::placeholder {
            color: rgb(64, 158, 255)!important;
        }
    }
}
</style>



// WEBPACK FOOTER //
// node_modules/macarons-graphs-front/src/filter/HierarchyFilter.vue